import WorkClient from '../api/workClient';

const getProductImage = (imageUrl: string) => {
  return WorkClient.getProductImage(imageUrl);
};

const ProductImageService = {
  getProductImage
};

export default ProductImageService;
